import { createAsyncThunk, createSlice, original } from "@reduxjs/toolkit";
import http from "../../net/http-common";
import { JOB_SERVER_URL } from "../../config";
import { isAxiosError } from "axios";
import { setGlobalMsgAlerts } from "../../components/GloablMsgAlerts/globalMsgAlertsSlice";
import { errorMessages } from "../../common_variables/ErrorMsgs";

interface stateType {
  status: "idle" | "loading" | "failed" | "successful";
  properties: {
    rowData: any[];
    input_ligand: string;
  };
  singleSmileData: {
    id: number;
    rankRowData: any[];
    evaluationIds: number[];
    data: any;
    taskId: string;
  };
  taskId: string;
}

const initialState: stateType = {
  status: "idle",
  properties: {
    rowData: [],
    input_ligand: "",
  },
  singleSmileData: {
    id: -1,
    rankRowData: [],
    evaluationIds: [],
    data: null,
    taskId: "",
  },
  taskId: "",
};

export const fetchHopperResults = createAsyncThunk(
  "hopper/fetchHopperResults",
  async (task_id: string, { dispatch }) => {
    try {
      const response = await http.get(
        `${JOB_SERVER_URL}/hopper/results?task_id=${task_id}&as_file=${false}`,
        {
          headers: {
            accept: "application/json",
          },
        }
      );
      return response.data;
    } catch (error) {
      let msg = "";
      if (isAxiosError(error)) {
        msg = error.response.data?.detail?.message;
      }
      dispatch(
        setGlobalMsgAlerts({
          msg: msg || errorMessages.jobResultError,
          isAlert: true,
          color: "error",
        })
      );
      throw error;
    }
  }
);

const hopperSlice = createSlice({
  name: "hopper",

  initialState,
  reducers: {
        setSingleSmileData: (state, action) => {
          state.singleSmileData.id = action.payload.id;
          state.singleSmileData.rankRowData = action.payload.rankRowData;
          state.singleSmileData.evaluationIds =
            action.payload.evaluationIds;
          state.singleSmileData.data = action.payload.data;
          state.singleSmileData.taskId = action.payload.taskId;
        },

        updateSmilesById: (state, action) => {
          const { id } = action.payload;
          const sliceData = original(state.singleSmileData);
          const smilesData = sliceData.rankRowData[sliceData.evaluationIds[id] - 1];
          state.singleSmileData.id = id;
          state.singleSmileData.data = smilesData;
        },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchHopperResults.rejected, (state, action: any) => {
        state.status = "failed";
      })
      .addCase(fetchHopperResults.pending, (state) => {
        state.status = "loading";
      })
      .addCase(
        fetchHopperResults.fulfilled,
        (state: stateType, action: any) => {
          state.properties.rowData = action.payload.results;
          state.properties.input_ligand = action.payload.input_ligand;
          state.taskId = action.payload.task_id;
          state.status = "successful";
        }
      );
  },
});

export const { setSingleSmileData, updateSmilesById } = hopperSlice.actions;
export default hopperSlice.reducer;
